<template>
  <div class="gc-grid-description-code-cell-template">
    <span class="gc-grid-description">{{ description }}</span>
    <span class="gc-grid-code">{{ code }}</span>
  </div>
</template>

<script>
export default {
  props: {
    description: {
      type: String,
    },
    code: {
      type: [String, Number],
    },
  },
  data() {
    return {};
  },
  created() {},
};
</script>

<style lang="scss" scoped>
  .gc-grid-description-code-cell-template{
    .gc-grid-code{
      font-size: 10px;
      padding-left: 5px;
    }
  }
</style>
